import { render, staticRenderFns } from "./addComputador.vue?vue&type=template&id=0f3dffcf&scoped=true&"
import script from "./addComputador.vue?vue&type=script&lang=js&"
export * from "./addComputador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3dffcf",
  null
  
)

export default component.exports